import { CrmLogo } from "../../icons"

export const UserImage = ({ image, size }: { image?: string, size?: string }) => {
    return image ? (
        <img
            alt=""
            src={image}
            className={`rounded-full ${size || "size-5"}`}
        />
    ) : (
        <CrmLogo className={`text-color7 fill-current ${size || "size-5"}`} />
    )
}